import React from 'react';
import { Admin } from './Admin';

function App(): React.ReactElement {
  return <Admin />;
}

export default App;
